export default "__VITE_ASSET__IZraFedF__"